import React, { useCallback } from 'react';
import { useMutation } from 'react-query';
import classNames from 'classnames';
import { IconAngleRight } from '@ace/react-icons';
import { RenderRawHTML, allActions } from '@ace/react-utilities';
import { CardLinkIconWrap } from 'Components/Card/CardLink';
import styles from 'assets/css/Message.module.css';
import { useDispatch } from 'react-redux';
import useSMARTGoalOverlay from 'context/SMARTGoalOverlayContext';

const Message = ({message}) => {
    const classes = classNames(styles.message, {
        [`${styles[`message--${message.Type}`]}`]: message.Type
    });
    const { mutate: dismissMutation }  = useMutation('dismissMessage');

    const dismissClick = useCallback(() => {
        dismissMutation(message.DismissCallbackURL);
    }, [message.DismissCallbackURL, dismissMutation]);

    const dispatch = useDispatch();
    const { toggleSMARTGoalsOverlay } = useSMARTGoalOverlay();

    const setActiveTab = useCallback((dashboardTabKey) => {
        dispatch(allActions.dashboardTabActions.setActiveTab(dashboardTabKey));
    }, [dispatch]);

    const isSMARTGoalMessageLink = message.ActionLink.MessageLinkType === 'SmartGoalMessageLink';
    const isDashboardTabNavigateLink = message.ActionLink.MessageLinkType === 'DashboardTabNavigateMessageLink';
    const isMessageLink = !isSMARTGoalMessageLink && !isDashboardTabNavigateLink;
    
    const InnerMessage = () => (
        <>
            {message.ActionLink.Text}
            <CardLinkIconWrap>
                <IconAngleRight />
            </CardLinkIconWrap>
        </>);

    return (
        <div className={classes}>
            <span className={styles.dismissButton} onClick={() => dismissClick()}>x</span>

            <span className={`${styles.messageType} ${styles[`messageType--${message.Type}`]}`}>
                {message.Type}
            </span>

            {message.Urgency ? <p className={styles.urgency}>{message.Urgency}</p> : null}

            {RenderRawHTML(message.Text, {className: styles.text})}

            {isMessageLink && message.ActionLink.Text &&
                // eslint-disable-next-line react/jsx-no-target-blank
                <a className={styles.link} href={message.ActionLink.URL || "/"} onClick={() => message.ActionLink.DismissOnLinkClick && dismissClick()} target="_blank" rel="noopener">
                    <InnerMessage />
                </a>}
            {isDashboardTabNavigateLink &&
                <span className={styles.link} onClick={() => setActiveTab(message.ActionLink.URL)}>
                    <InnerMessage />
                </span>}
            {isSMARTGoalMessageLink &&
                <span className={styles.link} onClick={() => toggleSMARTGoalsOverlay()}>
                    <InnerMessage />
                </span>}
        </div>
    );
}

export default Message;
